import SystemDashboard from '@/models/SystemDashboard'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import ClosedBusinessWidget from '../widgets/sales/ClosedBusinessWidget'
import FYOverviewWidget from '../widgets/finance/FYOverviewWidget'
import NewThisWeekWidget from '../widgets/finance/NewThisWeekWidget'
import CPMOverview from '../widgets/sales/CPMOverview'
import RevenueSegmentsWidget from '../widgets/finance/RevenueSegmentsWidget'

export default class SLTDashboardModule extends SystemDashboard {
  public title = 'SLT'

  public key: string = 'slt_dashboard'

  public querySettings = {
    company_fields: [
      {
        name: 'holding',
        key: 'holding',
        type: 'holding',
      },
      {
        name: 'agency',
        key: 'agency',
        type: 'agency',
      },
      {
        name: 'advertiser',
        key: 'advertiser',
        type: 'advertiser',
      },
    ],
    custom_fields: [
      {
        name: 'holding:independents',
        value: 'holding:null',
      },
      {
        name: 'deal_type:direct',
        value: 'deal_type:direct',
      },
      {
        name: 'deal_type:3rd Party',
        value: 'deal_type:3rd_party',
      },
    ],
    user_fields: [
      {
        name: 'sr',
        key: 'sales_rep_id',
      },
      {
        name: 'sm',
        key: 'sales_manager_id',
      },
    ],
  }

  public filters = {
    product: 'all',
    region: 'all',
    // ...FILTERS.LAST_4_WEEKS,
  }

  public groups = {
    // view: 'region',
    // period: 'week',
  }

  public widgets: SystemDashboardWidget[] = [
    new FYOverviewWidget(),
    new RevenueSegmentsWidget({
      title: 'Sales Channel',
      key: 'sales-channel',
      target: 'channel',
    }),
    new RevenueSegmentsWidget(),
    new CPMOverview({
      title: 'Direct Revenue CPMs',
      key: 'holding-cpms',
      size: {
        lg: 6,
        md: 12,
      },
      noPagination: true,
      target: 'holding',
    }),
    new CPMOverview({
      title: 'Regional & 3rd Party CPMs',
      key: 'region-cpms',
      size: {
        lg: 6,
        md: 12,
      },
      noPagination: true,
    }),
    new ClosedBusinessWidget({
      noPagination: true,
    }),
    new NewThisWeekWidget({
      title: 'Top Opportunities from pipeline',
      key: 'large-deals',
      orderBy: 'amount',
      sortDesc: true,
      noTotal: true,
      size: {
        lg: 12,
        md: 12,
      },
      internalFilters: {
        dynamic_filter: '',
      },
      perPage: 10,
      internalQuery: ['is:open', 'is:50_and_above'],
      rightCol: [],
      cellSlots: [
        {
          key: 'name',
          component: 'TableColLink',
          slotProps: (data: any) => ({
            link: `/app/opportunity/${data.item.id}`,
            innerText: data.item.name,
          }),
        },
      ],
      fields: [
        {
          key: 'status',
          label: 'Stage',
          class: 'text-center align-middle',
          show: true,
          type: 'capitalize_replace',
          thClass: 'align-middle text-center',
          sortable: true,
          filter: true,
        },
        {
          key: 'advertiser_id',
          label: 'Advertiser',
          class: 'text-center align-middle',
          show: true,
          type: 'object',
          object: {
            key: 'advertiser',
            property: 'name',
          },
          thClass: 'align-middle text-center',
          sortable: true,
        },
        {
          key: 'agency_id',
          label: 'Agency',
          class: 'text-center align-middle',
          show: true,
          type: 'object',
          object: {
            key: 'agency',
            property: 'name',
          },
          thClass: 'align-middle text-center',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Name',
          class: 'text-center align-middle',
          show: true,
          type: 'text',
          thClass: 'align-middle text-center',
          sortable: true,
          filter: true,
          templateLink: true,
          template: (item: any) => `<a href="/opportunities/${item.id}">${item.name}</a>`,
        },
        {
          key: 'sales_rep_id',
          label: 'Sales Rep',
          class: 'text-center align-middle',
          show: true,
          type: 'object',
          object: {
            key: 'sales_rep',
            property: 'name',
          },
          thClass: 'align-middle text-center',
          sortable: true,
        },
        {
          key: 'amount',
          label: 'Amount',
          class: 'text-center align-middle',
          show: true,
          type: 'currency_abbreviate',
          thClass: 'align-middle text-center',
          sortable: true,
          total: 'currency_abbreviate',
        },
        {
          key: 'revenue_period',
          label: 'Revenue Period',
          class: 'text-center align-middle',
          show: true,
          type: 'text',
          thClass: 'align-middle text-center',
          sortable: true,
        },
        {
          key: 'commentary',
          label: 'Comments',
          class: 'text-center align-middle',
          show: true,
          type: 'no_empty',
          thClass: 'align-middle text-center',
          sortable: true,
        },
      ],
    }),
  ]
}
